'use strict';

// export this package's api
module.exports = require('./Animate');


//////////////////
// WEBPACK FOOTER
// ./~/.2.3.3@rc-animate/lib/index.js
// module id = 75
// module chunks = 0